@use 'styles/functions/rem' as *;

.horizontalGridContainer {
    display: grid;
    grid-template-columns: rem(40px) 1fr;
}

.arrowLeftIcon {
    height: rem(40px);
    width: rem(40px);
}

.iconButton {
    align-items: flex-start;
}

.verticalContainer {
    max-width: rem(800px);
}
